module.exports = __webpack_public_path__ + "static/media/deleteicon.81571df2.svg";